import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { useLanguage } from '../context/LanguageContext';
import * as api from '../api';

const roleLabel = (role) => ({ superadmin: 'Bosh administrator', admin: 'Administrator', setter: 'O‘qituvchi', editor: 'Savol muharriri', participant: 'Talaba' }[role] || role);

export default function Profile() {
    const { user, updateUser } = useAuth();
    const toast = useToast();
    const { t } = useLanguage();
    const [form, setForm] = useState({ name: '', rollNumber: '', department: '' });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.getProfile().then((r) => setForm({
            name: r.data.name || '', rollNumber: r.data.rollNumber || '', department: r.data.department || ''
        })).catch((e) => toast(e.message, 'error')).finally(() => setLoading(false));
    }, []);

    const save = async (e) => {
        e.preventDefault(); setSaving(true);
        try {
            const r = await api.updateProfile(form);
            updateUser(r.data);
            toast('Profil saqlandi');
        } catch (e) { toast(e.message, 'error'); }
        finally { setSaving(false); }
    };

    if (loading) return <div className="page"><div className="spinner" /></div>;
    return (
        <div className="page" style={{ maxWidth: 700 }}>
            <div className="page-header"><div><h1>{t('profile')}</h1><p style={{ color: 'var(--muted)' }}>{roleLabel(user?.role)}</p></div></div>
            <form onSubmit={save} className="card">
                <div className="form-group"><label>Ism</label><input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
                <div className="form-row">
                    <div className="form-group"><label>Guruh / ID</label><input value={form.rollNumber} onChange={e => setForm({ ...form, rollNumber: e.target.value })} /></div>
                    <div className="form-group"><label>Fakultet / Kafedra</label><input value={form.department} onChange={e => setForm({ ...form, department: e.target.value })} /></div>
                </div>
                <div className="form-group"><label>Email</label><input value={user?.email || ''} disabled /></div>
                {user?.telegramUsername && <div className="form-group"><label>Telegram</label><input value={`@${user.telegramUsername}`} disabled /></div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button className="btn btn-primary" disabled={saving}>{saving ? 'Saqlanmoqda...' : 'Saqlash'}</button></div>
            </form>
        </div>
    );
}
